import LoginCard from '../auth/LoginCard.vue';
import RecoverPassword from '../auth/RecoverPassword.vue';
import ResetPassword from '../auth/ResetPassword.vue';
import AcceptInviteCard from '../user/invite/AcceptInviteCard.vue';

export default [
  {
    name: 'login',
    path: 'login',
    component: LoginCard,
  },
  {
    name: 'recover_password',
    path: 'recover-password',
    component: RecoverPassword,
  },
  {
    name: 'reset_password',
    path: 'reset-password/:token',
    component: ResetPassword,
    props: true,
  },
  {
    name: 'accept_invite',
    path: 'accept-invite/:token',
    component: AcceptInviteCard,
    props: true,
  },
];
